/**
 * Le rôle « Anonymous » n'existe plus (TEC-3156) : l'absence de rôle vaut « anonyme ».
 *
 * Patch rétro-compatible : certains tokens Auth0 déjà émis ou l'ancienne configuration du
 * tenant peuvent encore exposer « Anonymous » en dur dans le claim
 * `https://www.bloomays.com/roles`. On le retire systématiquement à la lecture du claim
 * (back comme front) pour ne jamais réintroduire ce rôle dans l'application.
 */
export const LEGACY_ANONYMOUS_ROLE = 'Anonymous';

export const stripLegacyAnonymousRole = <T extends string>(roles?: readonly T[] | null): T[] =>
  (roles ?? []).filter((role): role is T => role !== LEGACY_ANONYMOUS_ROLE);
